<script lang="ts">
    import dayjs from 'dayjs'
    import customParseFormat from 'dayjs/plugin/customParseFormat.js'
    dayjs.extend(customParseFormat)
    import { UserPermissions } from '../../../modules/usersApi/users/dto/user-permissions.dto'
    import { createEventDispatcher, onMount } from 'svelte'
    import { GridClass, GridCol, GridColTypeEnum, GridLine, GridZInput } from '../../_common/z/zgrid'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import Zflow from '../../_common/z/zflow.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import { AllowedHoursEntity } from '../../../modules/usersApi/companies/company'
    import Zinput from '../../_common/z/zinput.svelte'
    const dispatch = createEventDispatcher()

    export let userId
    export let permissions: UserPermissions
    export let allowLogin: boolean
    export let allowedHours: AllowedHoursEntity = new AllowedHoursEntity()

    let isOwner: boolean = userId === window.store?.company?.owner

    $: {
        loadGrids(permissions)
    }

    function ignore(key: string) {
        const bad = [
            'audience',
            'configurations',
            'Agenda > Comissões',
            'Agenda > configurations',
            'Agenda > Configurações',
            'PDV > Comissões',
            'Ferramentas > Provedores',
            'Ferramentas > Estoque',
            'Ferramentas > Relatórios',
        ]
        if (!window.beta) {
            bad.push('partnership')
            bad.push('tags')
        }

        if (bad.includes(key)) {
            return true
        }
        return false
    }

    function translate(parent: string, label: string) {
        //console.log('parent', parent)

        if (parent === 'Ferramentas') {
            if (label === 'referrals') return 'Origens do cliente'
            if (label === 'resources') return 'Salas e aparelhos'
            if (label === 'quotation') return 'Modelos de orçamento'
            if (label === 'payGateways') return 'Gateways de pagamento'
            if (label === 'customerService') return 'Modelos de atendimento'
            if (label === 'goals') return 'Configurações de metas'
            if (label === 'posTaxParams') return 'Configurações de notas fiscais'
        }

        if (label === 'finances') return 'Finanças'
        if (label === 'discount') return 'Desconto máximo permitido (%)'
        if (label === 'pos') return 'PDV'
        if (label === 'details') return 'Detalhamento'
        if (label === 'taxInvoices') return 'Nota Fiscal'
        if (label === 'quotes') return 'Orçamentos'
        if (label === 'sales') return 'PDV'
        if (label === 'scheduler') return 'Agenda'
        if (label === 'comissions') return 'Comissões'
        if (label === 'self') return 'Do próprio usuário'
        if (label === 'others') return 'De outro usuário'
        if (label === 'read') return 'Ver'
        if (label === 'write') return 'Alterar'
        if (label === 'navigate') return 'Navegar por datas antigas'
        if (label === 'customerService') return 'Atendimento'
        if (label === 'dashboard') return 'Dashboard'
        if (label === 'marketing') return 'Automações'
        if (label === 'partnership') return 'Parceiros'
        if (label === 'partners') return 'Parceiros'
        if (label === 'entries') return 'Lançamentos'
        if (label === 'referral') return 'Indicações'
        if (label === 'referrals') return 'Indicações'
        if (label === 'goals') return 'Metas'
        if (label === 'general') return 'Geral'
        if (label === 'individual') return 'Individual'
        if (label === 'configs') return 'Configurações'
        if (label === 'stock') return 'Estoque'
        if (label === 'inputs') return 'Entradas'
        if (label === 'outputs') return 'Saídas'
        if (label === 'financial') return 'Financeiro'
        if (label === 'financials') return 'Financeiros'
        if (label === 'reports') return 'Relatórios'
        if (label === 'pay') return 'ZanduPay'
        if (label === 'links') return 'Links'
        if (label === 'gateways') return 'Gateways'
        if (label === 'tags') return 'Etiquetas'

        if (label === 'pipeline') return 'Pipeline'
        if (label === 'account') return 'Menu conta'
        if (label === 'devices') return 'Dispositivos'
        if (label === 'users') return 'Usuários'
        if (label === 'companies') return 'Empresas'
        if (label === 'persons') return 'Pessoas'
        if (label === 'tabs') return 'Aba'
        if (label === 'forms') return 'Atendimento'

        if (label === 'show') return 'Exibir recurso'
        if (label === 'nps') return 'NPS'
        if (label === 'tools') return 'Ferramentas'
        if (label === 'notes') return 'Notas'
        if (label === 'events') return 'Eventos'
        if (label === 'balance') return 'Saldos'
        if (label === 'audience') return 'Públicos'
        if (label === 'prospect') return 'Prospecção'
        if (label === 'services') return 'Serviços'
        if (label === 'providers') return 'Provedores'
        if (label === 'schedules') return 'Agendas'
        if (label === 'super') return 'Super usuário'
        if (label === 'payments') return 'Meios de pagamento'
        if (label === 'categories') return 'Categorias financeiras'
        if (label === 'docs') return 'Documentos'
        if (label === 'accounts') return 'Contas bancárias'
        if (label === 'configurations') return 'Configurações'
        if (label === 'outbox') return 'Caixa de saída'
        if (label === 'templates') return 'Templates'
        if (label === 'app') return 'Meu aplicativo'

        //console.log('translate', parent, label)
        return label
    }

    let grids: GridClass[] = []
    function loadGrids(perms: UserPermissions) {
        //console.log('perms_loaded', perms)
        grids = []
        if (!perms) return
        // primeiro carrega propriedades na raiz que não sejam objetos (ex.: super = true)
        for (const [key, value] of Object.entries(perms)) {
            if (typeof perms[key] !== 'object') {
                if (ignore(key)) continue
                let grid = new GridClass()
                grid.title = translate(null, key)
                grid.showActs = false
                grid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.zinput, size: 1 }))
                grid.cols.push(new GridCol({ content: 'Recurso', type: GridColTypeEnum.string }))
                loadLines(grid, key, null, key, perms)
                grids.push(grid)
            }
        }
        // depois carrega todos os objetos
        for (const [key, value] of Object.entries(perms)) {
            if (typeof perms[key] === 'object') {
                if (ignore(key)) continue
                let grid = new GridClass()
                grid.title = translate(null, key)
                grid.showActs = false
                grid.cols.push(new GridCol({ content: 'Status', type: GridColTypeEnum.zinput, size: 1 }))
                grid.cols.push(new GridCol({ content: 'Recurso', type: GridColTypeEnum.string }))
                loadLines(grid, key, null, key, perms)
                grids.push(grid)
            }
        }
    }

    function loadLines(grid: GridClass, firstLevelKey: string, path: string, key: string, object) {
        if (key === 'reports') {
            //console.log('rep', object[key])
        }
        const translated = translate(path, key)
        // se a propriedade passada não é um objeto
        if (typeof object[key] !== 'object') {
            return addToGrid(grid, firstLevelKey, path, translated, object, key)
        }
        const entries = Object.entries(object[key])
        // para ordenar, exibindo as raízes primeiro, faz-se 2 loops
        for (const [key_2, value_2] of entries) {
            if (typeof value_2 === 'object') continue
            loadLines(grid, firstLevelKey, (path ? path + ' > ' : '') + translated, key_2, object[key])
        }
        for (const [key_2, value_2] of entries) {
            if (typeof value_2 !== 'object') continue
            loadLines(grid, firstLevelKey, (path ? path + ' > ' : '') + translated, key_2, object[key])
        }
    }

    function addToGrid(grid, firstLevelKey: string, path: string, label: string, object, key) {
        if (ignore(path)) return
        if (ignore(key)) return

        let line: GridLine = new GridLine()

        let type: any = 'toggle'
        if (typeof object[key] === 'number') type = 'number'
        let act: GridZInput = new GridZInput({
            callback: (c) => {
                console.log('callback', permissions)
                object[key] = c
                permissions = permissions
            },
            value: object[key],
            type: type,
            disabled: isDisabled(path, firstLevelKey, key),
            class: 'zinput-disabled-nobackground',
        })
        line.slots.push({ content: act })
        line.slots.push({ content: (path ? path + ' > ' : '') + label })
        grid.lines.push(line)
    }

    function isDisabled(path: string, firstLevelKey: string, key: string) {
        if (isOwner) return true
        if (!allowLogin) return true
        if (!path) return false
        if (permissions.super) return true
        if (key === 'show') return false
        if (permissions[firstLevelKey]?.show === false) return true
        return false
    }

    async function allowLoginOnChange() {
        permissions = permissions
    }

    let intervalMinutes: { fromTime: string; toTime: string; weekDay: number }[] = []
    function fromInterval_To_IntervalString() {
        intervalMinutes = []
        for (const day of allowedHours.interval) {
            const fromTime = dayjs().startOf('day').add(day.fromTime, 'minute').format('HH:mm')
            const toTime = dayjs().startOf('day').add(day.toTime, 'minute').format('HH:mm')
            intervalMinutes.push({ fromTime, toTime, weekDay: day.weekDay })
        }
        intervalMinutes = intervalMinutes
    }
    function fromIntervalString_to_Interval() {
        allowedHours.interval = []
        for (const day of intervalMinutes) {
            const fromTime = dayjs(day.fromTime, 'HH:mm').hour() * 60 + dayjs(day.fromTime, 'HH:mm').minute()
            const toTime = dayjs(day.toTime, 'HH:mm').hour() * 60 + dayjs(day.toTime, 'HH:mm').minute()
            allowedHours.interval.push({ fromTime, toTime, weekDay: day.weekDay })
        }
        console.log('newAllowedHours', allowedHours)
    }

    let days = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado']
    onMount(() => {
        fromInterval_To_IntervalString()
    })
</script>

<div class="user-perms mt-3 pb-6">
    <Zframe title="Permitir login" class="mb-3">
        <div class="form-check">
            <input
                disabled={isOwner}
                class="form-check-input"
                bind:checked={allowLogin}
                on:change={allowLoginOnChange}
                type="checkbox"
                role="switch"
                id="consulting"
            />
            <label class="form-check-label" for="consulting">Permitir que este usuário possa fazer login na empresa</label>
        </div>
        {#if allowLogin}
            <div class="config-box mt-2">
                <div class="form-check">
                    <input disabled={isOwner} class="form-check-input" bind:checked={allowedHours.active} type="checkbox" role="switch" id="hourTime" />
                    <label class="form-check-label" for="hourTime">Limitar horários de acesso</label>
                </div>
                {#if allowedHours.active}
                    <div class="mt-2 mb-3 text-muted">
                        Informe os horários <b>permitidos</b> para acesso.<br />Para bloquear o acesso em determinado dia informe 0:00 no horário de início e
                        fim.<br />
                        Importante: o bloqueio do usuário logado pode ocorrer em até 5 minutos após o horário final configurado.
                    </div>
                    {#each intervalMinutes as day, index}
                        <div class="d-flex align-items-center gap-2 mb-1">
                            <label style="width:120px;" for="start" class="form-label mb-0">{days[index]}</label>
                            <input
                                bind:value={day.fromTime}
                                type="time"
                                id="start"
                                class="form-control"
                                style="width:130px;"
                                on:change={fromIntervalString_to_Interval}
                            />
                            <label for="end" class="form-label mb-0">até</label>
                            <input
                                bind:value={day.toTime}
                                type="time"
                                id="end"
                                class="form-control"
                                style="width:130px;"
                                on:change={fromIntervalString_to_Interval}
                            />
                        </div>
                    {/each}
                {/if}
            </div>
        {/if}
    </Zframe>
    <Zflow>
        {#each grids as grid}
            <Zgrid {grid}></Zgrid>
        {/each}
    </Zflow>
</div>

<style>
</style>
